import React from "react";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { SovosLink, SovosMenuItem, SovosToolbar, SovosToolbarActions, SovosToolbarMoreMenu, SovosTypography } from "mosaic-react";
import { createLink } from "../../../utils";
import LineStatus from "../LineStatus/LineStatus";
import { useTheme } from "mosaic-react/styles";
import UserAvatar from "../UserAvatar/UserAvatar";
import { Download } from "mosaic-react-icons";
const handleLinkClick = event => {
  event.stopPropagation();
};
const CellCard = props => {
  const {
    params,
    proxy,
    customCardsCells,
    i18n,
    downloadFile
  } = useGlobalValue();
  const theme = useTheme();
  // TODO: use prop filter to highlight corresponding
  const {
    value: cell,
    type
  } = props;
  let valueElement;
  switch (type) {
    case "userWithAvatar":
      valueElement = /*#__PURE__*/React.createElement(UserAvatar, {
        value: cell
      });
      break;
    case "customComponent":
      {
        const {
          customComponent
        } = cell || {};
        const CustomComponent = customCardsCells && customCardsCells[customComponent] ? customCardsCells[customComponent] : null;
        return CustomComponent && /*#__PURE__*/React.createElement(CustomComponent, props);
      }
    case "downloadLine":
      const {
        fileName,
        id,
        generationStatus,
        entity
      } = cell || {};
      valueElement = /*#__PURE__*/React.createElement(SovosToolbar, null, /*#__PURE__*/React.createElement(SovosToolbarActions, null, /*#__PURE__*/React.createElement(SovosToolbarMoreMenu, {
        disabled: !["success"].includes(generationStatus)
      }, /*#__PURE__*/React.createElement(SovosMenuItem, {
        onClick: () => {
          downloadFile({
            fileName,
            importId: id,
            id,
            entity
          });
        }
      }, /*#__PURE__*/React.createElement(Download, null), /*#__PURE__*/React.createElement(SovosTypography, {
        children: i18n`Download`,
        variant: "span"
      })))));
      break;
    case "status":
    case "fileStatus":
      valueElement = /*#__PURE__*/React.createElement(LineStatus, {
        value: cell
      });
      break;
    case "repoHasFindings":
      if (cell && cell.name) {
        if (cell.id && cell.customParam) {
          valueElement = /*#__PURE__*/React.createElement(SovosLink, {
            sx: {
              color: theme.palette.primary.main
            },
            href: createLink(undefined, proxy, cell, {
              ...params,
              ...cell.customParam
            }),
            onClick: handleLinkClick
          }, cell.name);
        } else {
          valueElement = /*#__PURE__*/React.createElement(SovosTypography, {
            sx: {
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.text.primary
            },
            variant: "body2"
          }, cell.name);
        }
      }
      break;
    case "object":
      if (cell && cell.id && (cell.name === 0 || !!cell.name) && cell.customParam) {
        valueElement = /*#__PURE__*/React.createElement(SovosLink, {
          href: createLink(undefined, proxy, cell, {
            ...params,
            ...cell.customParam
          })
        }, cell.name);
      } else if (cell && cell.id && cell.name) {
        valueElement = /*#__PURE__*/React.createElement(SovosLink, {
          href: createLink(undefined, proxy, cell, params),
          label: cell.name
        }, cell.name);
      } else {
        if (typeof cell === "object") {
          console.warn("Invalid cell. Cell must be a string!");
          return;
        }
        valueElement = /*#__PURE__*/React.createElement(SovosTypography, {
          sx: {
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          variant: "body2"
        }, cell);
      }
      break;
    case "stringWithColor":
      const {
        color,
        family,
        label
      } = cell || {};
      valueElement = /*#__PURE__*/React.createElement(SovosTypography, {
        sx: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          color: theme.palette[family]?.[color]
        },
        variant: "body2",
        children: label
      });
      break;
    case "percentage":
      valueElement = /*#__PURE__*/React.createElement(SovosTypography, {
        sx: {
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        variant: "body2",
        children: `${cell}%`
      });
      break;
    default:
      valueElement = /*#__PURE__*/React.createElement(SovosTypography, {
        sx: {
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        variant: "body2"
      }, typeof cell === "object" ? "" : cell);
  }
  return valueElement;
};
export default CellCard;